import { Check, CloseCircleOutlined, InfoCircleOutlined, Spinner, Warning } from '@eventespresso/icons';

const toasterIcons = {
	error: <CloseCircleOutlined />,
	info: <InfoCircleOutlined />,
	loading: <Spinner />,
	success: <Check />,
	warning: <Warning />,
};

export default toasterIcons;
